<div class="container-fluid" style="padding: 0;">
    <div class="row ">
      <div class="col-md-12 text-right"></div>
    </div>

   
      <div class="ng-Header col-xs-12 mt-2">
        <i nz-icon nzType="unordered-list" nzTheme="outline"></i> Search Panel

      </div>
      <form
        nz-form
        [formGroup]="searchingForm"
        class="ant-advanced-search-form"
        style="
          padding: 24px;
          background: #fbfbfb;
          border: 1px solid #d9d9d9;
          border-radius: 6px;
        "
        (ngSubmit)="getMinistryList()"
      >
        <div class="form-row" style="margin-left: 12px">
          <div class="col-md-6">
            <nz-form-label>Ownership Type</nz-form-label>
            <div class="col-md-12">
              <nz-form-item>
                <nz-form-control [nzSpan]="20">
                  <nz-select
                    class="row mt-2"
                    nzShowSearch
                    nzAllowClear
                    id="levelId"
                    formControlName="stpOwnershipTypeId"
                    nzPlaceHolder="Please select industrial sector"
                  >
                    <nz-option
                      *ngFor="let stpOwnershipType of stpOwnershipType"
                      [nzValue]="stpOwnershipType.id"
                      [nzLabel]="stpOwnershipType.name"
                    >
                    </nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>

          <div class="col-md-6">
            <nz-form-label>Ministry</nz-form-label>
            <div class="col-md-12">
              <nz-form-item>
                <nz-form-control [nzSpan]="20">
                  <input
                  nz-input
                  formControlName="ministryName"
                  placeholder="Name of Ministry"
                  maxlength="255"
                />

                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
        </div>

        <div nz-row>
          <div nz-col [nzSpan]="24" class="search-area text-right">
            <button class="mr-2 col-md-2 col-sm-12 mt-2" nz-button [nzType]="'primary'">Search</button>
            <button
              class="mr-2 btn-success col-md-2 col-sm-12 mt-2"
              type="button"
              nz-button
              (click)="reset()"
            >
              Refresh Data
            </button>

          </div>
        </div>
      </form>
   

    
      <div class="ng-Header col-xs-12">
        <i nz-icon nzType="unordered-list" nzTheme="outline"></i> List of Ministries
      </div>
      <div nz-col [nzSpan]="24">
        <nz-table
          #list
          [nzData]="listView"
          nzTableLayout="fixed"
          nzShowSizeChanger
          nzBordered
          nzSize="middle"
          nzAlign="middle"
          [nzFrontPagination]="true"

          [nzTotal]="total"
          [(nzPageSize)]="size"
          [nzShowTotal]="totalRowRangeTemplate"
          [(nzPageIndex)]="page"
          (nzQueryParams)="onQueryParamsChange($event)"
          [nzScroll]="{ x: '1150px' }"
        >
          <ng-template
            #totalRowRangeTemplate
            let-range="range"
            let-total
            style="text-align: left"
          >
            <div style="text-align: left">
              Showing {{ range[0] }}-{{ range[1] }} of {{ total }} items
            </div>
          </ng-template>

          <thead>
            <tr style="overflow: auto">
              <th style="width: 3%; text-align: center " rowspan="1" n>Sl.</th>

              <th style="width: 25%; text-align: center" rowspan="2" nzColumnKey="ministryName"
              [nzSortFn]="true">
                Ministry Name
              </th>
              <th style="width: 8%; text-align: center" rowspan="2" nzColumnKey="stpOwnershipTypeName" [nzSortFn]="true">
                Ownership Type
              </th>
              <th style="width: 20%; text-align: center" rowspan="2">
                Remarks
              </th>


              <th style="width: 7%; text-align: center" rowspan="2">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of list?.data; let i = index">
              <td style="text-align: center">
                {{ (page - 1) * size + 1 + i }}
              </td>


              <td style="text-align: center">{{ data.ministryName }}</td>
              <td style="text-align: center">{{ data.stpOwnershipTypeName }}</td>
              <td style="text-align: center">{{ data.remarks }}</td>

              <td style="text-align: center">
                <button
                  title="Edit"
                  (click)="onEdit(data.id)"
                  nz-button
                  nzType="default"
                  [nzSize]="'small'"

                >
                  <i nz-icon nzType="edit" nzTheme="fill"></i>
                </button>
                |
                <button
                  nz-popconfirm
                  nzPopconfirmTitle="Are you sure delete this Ministry?"
                  nzPopconfirmPlacement="bottom"
                  (nzOnConfirm)="onDelete(data.id)"
                  nz-button
                  nzType="default"
                  [nzSize]="'small'"

                >
                  <i nz-icon nzType="delete" nzTheme="fill"></i>
                </button>


              </td>
            </tr>
          </tbody>
        </nz-table>
      </div>
    
  </div>


